import { Content, GroupsInfo, PhaseWithContent, Student } from '@monorepo/golab-generated'
import { Actor, ILSStructure } from '@monorepo/next-lab'
import { BehaviorSubject } from 'rxjs'
import { Injectable } from '@angular/core'
import { DrawerModelService } from './auto-resize-element.service'

@Injectable()
export abstract class IlsModelPartsService implements DrawerModelService {
  readonly phaseListVisible$ = new BehaviorSubject<boolean>(true)
  readonly globalContentVisible$ = new BehaviorSubject<boolean>(false)
  readonly leftDrawerVisible$ = this.phaseListVisible$
  readonly rightDrawerVisible$ = this.globalContentVisible$

  protected _ilsId = ''

  readonly published$ = new BehaviorSubject<boolean>(false)
  readonly learningAnalyticsEnabled$ = new BehaviorSubject<boolean>(false)
  readonly enableNavigationButtons$ = new BehaviorSubject<boolean>(false)
  readonly language$ = new BehaviorSubject<string>('en')
  readonly title$ = new BehaviorSubject<string>('?')

  readonly globalContentList$ = new BehaviorSubject<Content[]>([])

  readonly phaseList$ = new BehaviorSubject<PhaseWithContent[]>([])

  get hasRightDrawerContent(): boolean {
    return this.globalContentList$.value.length > 0
  }

  get ilsId(): string {
    return this._ilsId
  }

  getIlsStructure(): ILSStructure {
    throw new Error('Method not implemented.')
  }

  createStudent(nickname: string): Promise<Actor> {
    throw new Error('Method not implemented.')
  }

  getStudents(): Promise<Actor[]> {
    throw new Error('Method not implemented.')
  }

  getAllStudents(): Promise<Student[]> {
    throw new Error('Method not implemented.')
  }
  getGroupsInfo(): Promise<GroupsInfo> {
    throw new Error('Method not implemented.')
  }

  findPhaseWithContent(contentId: string | undefined): PhaseWithContent | undefined {
    if (!contentId || this.phaseList$.value.length === 0) {
      return undefined
    }
    for (const phase of this.phaseList$.value) {
      if (phase.contentList.some(content => content._id === contentId)) {
        return phase
      }
    }
    return undefined
  }
}
